import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { AverbacaoNacionalidadeService } from '@/core/api/sicom-api/servicos/pessoa-fisica/averbacao-nacionalidade/averbacao-nacionalidade.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { AverbacaoNacionalidadeDTO, AverbacaoNacionalidadeRequest, AverbacaoNacionalidadeResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/averbacao-nacionalidade/averbacao-nacionalidade.model';

@Injectable({ providedIn: 'root' })
export class AverbacaoNacionalidadeServicosService {
    constructor(
        private api: AverbacaoNacionalidadeService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: AverbacaoNacionalidadeRequest, context?: HttpContext): Observable<AverbacaoNacionalidadeResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    efetivarSolicitacao(dto: AverbacaoNacionalidadeDTO, context?: HttpContext): Observable<void> {
        if (!dto?.numeroProtocolo || !dto?.anoProtocolo || !dto?.ufCrmOrigem) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrmOrigem são obrigatórios para efetivar.'));
        }

        return this.api.efetivarSolicitacao(dto, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
